export default class Config {
  static baseUrl = process.env.REACT_APP_API_URL
  static apiUrl = Config.baseUrl + '/api/v1/'
  static adminPath = '/admin'
}
